<div class="conditional__selected-card">
  <div class="conditional__selected-card-title">
    <ng-content select="[slot=badge]"></ng-content>
    <span class="conditional__selected-card-text fs__md"><ng-content select="[slot=title]"></ng-content></span>

    <button mat-icon-button title="Clear selection" class="clear-button" (click)="onClear.emit()">
      <fa-icon [icon]="faClose"></fa-icon>
    </button>
  </div>
  <span class="conditional__selected-card-text fs__md"><ng-content select="[slot=text]"></ng-content></span>
</div>
